import { IItemVideo, IListVideo } from '../../../interface/interface';


interface IItemVideos {
    videoId: string,
    channelId: string,
    title: string,
    description: string,
    imageM: string,
    imageH: string,
    channelTitle: string,
}

interface INewResponseVideos {
    nextPageToken: string,
    items: IItemVideos
}

interface INewResponseLists {
    listId: string,
    name: string,
    description: string,
    createBy: string,
}

interface IDataVideo {
    videoId: string,
    title: string,
    image: string,
    channel: string,
}



export const adapterInfoResponse = (response: any) => {
    // console.log(response, 'data en adapterInfoResponse');

    if (response.status === 200) {
        let items: IItemVideos = response.data.items?.map((i: any) => {
            return {
                videoId: i.id.videoId,
                channelId: i.snippet.channelId,
                title: i.snippet.title,
                description: i.snippet.description,
                imageM: i.snippet.thumbnails.medium.url,
                imageH: i.snippet.thumbnails.high.url,
                channelTitle: i.snippet.channelTitle

            }
        })

        let newResponse: INewResponseVideos = {
            nextPageToken: response.data.nextPageToken,
            items: items
        };

        // console.log(newResponse, 'newResponse');

        return newResponse;

    }
    return response.data;
}

export const adapterChannelResponse = (response: any) => {
    // console.log(response, 'data en adapterChannelResponse');

    if (response.status === 200) {
        let items: IItemVideos = response.data.items?.map((i: any) => {
            return {
                videoId: i.id.videoId,
                channelId: i.snippet.channelId,
                title: i.snippet.title,
                description: i.snippet.description,
                imageM: i.snippet.thumbnails.medium.url,
                imageH: i.snippet.thumbnails.high.url,
                channelTitle: i.snippet.channelTitle

            }
        })

        let newResponse: INewResponseVideos = {
            nextPageToken: response.data.nextPageToken,
            items: items
        };

        // console.log(newResponse, 'newResponse');

        return newResponse;

    }
    return response.data;

}

export const adapterListsResponse = (response: any) => {
    // console.log(response, 'data en adapterListsResponse');
    if (response.status === 200) {
        let newResponse: INewResponseLists = response.data.data?.map((i: any) => {
            return {
                listId: i._id,
                name: i.name,
                description: i.description,
                createBy: i.createBy,
            }
        });

        // console.log(newResponse, 'newResponse');

        return newResponse;

    }
    return response.data;


}

export const adapterListVideo = (response: any) => {
    // console.log(response, 'data en adapterListVideo');

    if (response.status === 200) {
        const videos: IItemVideo[] = response.data.data.videos?.map((i: any) => {
            return {
                position: i.position,
                videoId: i.videoId,
                title: i.title,
                image: i.image,
                channel: i.channel,
            }
        });

        let newResponse: IListVideo = {
            listId: response.data.data._id,
            name: response.data.data.name,
            description: response.data.data.description,
            createBy: response.data.data.createBy,
            videos: videos
        }


        // console.log(newResponse, 'newResponse');

        return newResponse;

    }
    return response.data;

}

// export const adapterListsResponse = (response: any) => {
//     console.log(response, 'data en adapterListsResponse');
//     if (response.status === 200) {
//         let items:IItemLists = response.data.items?.map((i:any)=> {
//             return {
//                 videoId: i.id.videoId,
//                 channelId: i.snippet.channelId,
//                 title: i.snippet.title,
//                 description: i.snippet.description,
//                 image: i.snippet.thumbnails.medium.url,
//                 channelTitle: i.snippet.channelTitle
//             }
//         })
//         let newResponse: INewResponseLists = {
//             name: response.data.nextPageToken,
//             description: response.data.description,
//             createBy: response.data.createBy,
//             items: items
//         };
//         console.log(newResponse, 'newResponse');
//         return newResponse;
//     }
//     return response.data;
// }